import { Helmet } from 'react-helmet-async';
import { filter, isArray } from 'lodash';
import React, { useState, useEffect } from 'react';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
} from '@mui/material';
// components
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
// mock
import SteLib from 'src/lib/stelib';
import EditMoviePopup from 'src/components/stComponents/EditMoviePopup';
import { useNavigate } from 'react-router-dom';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'id', label: 'Id', alignRight: false },
  { id: 'title', label: 'Titolo', alignRight: false },
  { id: 'genre', label: 'Genere', alignRight: false },
  { id: 'duration', label: 'Durata', alignRight: false },
  { id: '' },
];
// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  if(Array.isArray(array))
  {
    const stabilizedThis = array?.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    if (query) {
      return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
    }
    return stabilizedThis.map((el) => el[0]);
  }
  else {
    return []
  }
}

export default function AdminDashboardPage() {

  const [firstTime, setFirstTime] = useState(true);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [orderBy, setOrderBy] = useState('id');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(50);

  const [movies, setMovies] = useState([])

  const [openEdit, setOpenEdit] = useState(false);
  const [editData, setEditData] = useState(undefined);
  
  const navigate = useNavigate();

  useEffect(() => {
    if(firstTime)
    {
      getMovies();
    }
    setFirstTime(false);
  }, [firstTime]);
  
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
   };

  const getMovies = () => {
    SteLib.GetRequest("movies", {}, {}).then((data) => {
      if(isArray(data))
      {
        data.map(d => {
          if(!isNaN(d.id))
          {
            d.id = parseInt(d.id);
          }
          return true;
        });
      }
      setMovies(data)
    });
  }

  //getUser();

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - movies.length) : 0;

  const filteredMovies = applySortFilter(movies, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredMovies.length && !!filterName;

  let openEditPopup = (id) => {
    if(id > 0)
    {
      SteLib.GetRequest("movies/"+id, {}, {}).then((data) => {
        if(data !== undefined)
        {
          setOpenEdit(true);
          setEditData(data);
        }
      });
    }
  }

  let deleteMovie = (id) => {
    if(id > 0)
    {
      if(window.confirm("Sei sicuro?"))
      {
        SteLib.DeleteRequest("movies/"+id, {}, false).then((data) => {
          getMovies();
        });
      }
    }
  }
  
  let listTimetables = (id) => {
    navigate(`${process.env.PUBLIC_URL}/admin/movies/`+id, { replace: true });
  }

  return (
    <>
      <Helmet>
        <title> Dashboard </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Dashboard
          </Typography>
          <EditMoviePopup setOpenEdit={setOpenEdit} openEdit={openEdit} editData={editData} setEditData={setEditData} successCallback={getMovies}/>
        </Stack>

        <Card>
          <UserListToolbar filterName={filterName} onFilterName={handleFilterByName} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={Array.isArray(movies) ? movies.length : 0}
                  //numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  //onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredMovies.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const { id, title, genre, duration } = row;

                    return (
                      <TableRow hover key={id} tabIndex={-1}>
                        {<>&nbsp;</>/*<TableCell padding="checkbox">
                          <Checkbox checked={selectedUser} onChange={(event) => handleClick(event, name)} />
                        </TableCell>*/}

                        <TableCell align="left">{id}</TableCell>

                        <TableCell component="th" scope="row" padding="none">
                          <Stack direction="row" alignItems="center" spacing={2}>
                            {/*<Avatar alt={name} src={avatarUrl} />*/}
                            <Typography variant="subtitle2" noWrap>
                              {title}
                            </Typography>
                          </Stack>
                        </TableCell>


                        <TableCell align="left">{genre}</TableCell>

                        <TableCell align="left">{duration}</TableCell>


                        <TableCell align="right">
                          <IconButton onClick={() => openEditPopup(id)}>
                            <Iconify icon={'eva:edit-fill'} />
                          </IconButton>
                          <IconButton sx={{color: '#1879ad'}} onClick={() => listTimetables(id)}>
                            <Iconify icon={'eva:film-outline'} />
                          </IconButton>
                          <IconButton sx={{color: 'error.main'}} onClick={() => deleteMovie(id)}>
                            <Iconify icon={'eva:trash-2-outline'} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Non trovato
                          </Typography>

                          <Typography variant="body2">
                            Nessun risultato trovato per &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Prova cercando parti di testo o parole complete.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[25, 50, 100]}
            component="div"
            count={Array.isArray(movies) ? movies.length : 0}
            rowsPerPage={rowsPerPage}
            page={page}
            labelRowsPerPage='Righe per pagina:'
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} di ${count}`}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
      
      
    </>
  );
}
